<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                <PreviousOrders
                    title="Orders For Today"
                    :search="todaySearch"
                    :manualSearch="false"
                    :startingRowsPerPage="5"
                    :startingDescending="false"
                ></PreviousOrders>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12>
                <PreviousOrders
                    title="Previous Orders"
                    :search="thisWeekSearch"
                    :manualSearch="false"
                    :startingRowsPerPage="5"
                    :startingDescending="true"
                ></PreviousOrders>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import PreviousOrders from "./orders/PreviousOrders.vue";
import util from "@/services/util";

export default {
    components: {
        PreviousOrders
    },
    props: [
        
    ],
    data() {
        return {
            todaySearch: {
                date: util.today()
            },
            thisWeekSearch: {
                minDate: util.addDays(util.today(), 1),
            }
        };
    },
    computed: {
        
    },
    methods: {
        loadPublicHolidays() {
            this.$store.dispatch("publicHolidayStore/loadPublicHolidays");
        },
        loadStores() {
            this.$store.dispatch("storeStore/loadStores");
        },
        loadSuppliers() {
            this.$store.dispatch("supplierStore/loadSuppliers");
        }
    },
    created(){
        this.loadPublicHolidays();
        this.loadStores();
        this.loadSuppliers();
    }
};
</script>

<style>
    
</style>